import { isStage } from './isStage';

export const isProd = !isStage && process.env.NODE_ENV === 'production';
